<template>
  <Textarea
    autoResize
    @blur="onFocus(false)"
    @focus="onFocus(true)"
    unstyled
    :pt="{
      root: {
        class: [
          'w-full outline-0 bg-white dark:bg-slate-700',
          focus ? focusClass:'',
          transitionClass,
          paddingClass,
          borderClass,
          textClass
        ]
      }
    }"
  />
</template>

<script>

import Textarea from 'primevue/textarea';

export default {
  name: "RpmTextareaInput",
  components: {
    Textarea
  },
  data() {
    return {
      focus: false
    }
  },
  props: {
    focusClass: {
      type: String,
      default: ""
    },
    borderClass: {
      type: String,
      default: ""
    },
    paddingClass: {
      type: String,
      default: ""
    },
    transitionClass: {
      type: String,
      default: ""
    },
    textClass: {
      type: String,
      default: ""
    },
  },
  methods: {
    onFocus(bool) {
      this.focus = bool;
    }
  }
};

</script>
